import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <div className="forum-container" style={{ 
      minHeight: '60vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      textAlign: 'center'
    }}>
      <div style={{ maxWidth: '500px', padding: '40px' }}>
        <h2 style={{ 
          color: '#00bfff', 
          fontWeight: 'bold', 
          fontSize: '48px', 
          margin: '0 0 8px',
          textShadow: '0 0 20px rgba(0, 191, 255, 0.5)'
        }}>
          404
        </h2>
        <h1 style={{ 
          fontSize: '28px', 
          fontWeight: '300', 
          color: '#ffffff', 
          margin: '0 0 16px',
          textShadow: '0 0 10px rgba(0, 191, 255, 0.3)'
        }}>
          Page Not Found
        </h1>
        <p style={{ 
          lineHeight: '140%', 
          margin: '16px 0 24px', 
          fontSize: '14px', 
          color: '#e0e0e0'
        }}>
          The page you're looking for seems to have vanished just like the mysterious Goosifer.
        </p>
        
        <div style={{
          background: 'rgba(0, 191, 255, 0.1)',
          border: '1px solid rgba(0, 191, 255, 0.3)',
          borderRadius: '4px',
          padding: '20px',
          margin: '20px 0',
          textAlign: 'left'
        }}>
          <h4 style={{ color: '#00bfff', marginBottom: '10px', fontSize: '16px' }}>
            🔍 Looking for something specific?
          </h4>
          <ul style={{ listStyle: 'none', paddingLeft: '0' }}>
            <li style={{ color: '#e0e0e0', marginBottom: '5px', fontSize: '14px' }}>
              <span style={{ color: '#00bfff', fontWeight: 'bold' }}>• </span>
              <strong>Goosifer Sightings:</strong> Check out recent encounters and evidence
            </li>
            <li style={{ color: '#e0e0e0', marginBottom: '5px', fontSize: '14px' }}>
              <span style={{ color: '#00bfff', fontWeight: 'bold' }}>• </span>
              <strong>Search Party Info:</strong> Learn about the annual Denver Search Party
            </li>
            <li style={{ color: '#e0e0e0', marginBottom: '5px', fontSize: '14px' }}>
              <span style={{ color: '#00bfff', fontWeight: 'bold' }}>• </span>
              <strong>Community Discussion:</strong> Join conversations about the Colfax Creature
            </li>
            <li style={{ color: '#e0e0e0', marginBottom: '5px', fontSize: '14px' }}>
              <span style={{ color: '#00bfff', fontWeight: 'bold' }}>• </span>
              <strong>Photo Evidence:</strong> View submitted images and videos
            </li>
          </ul>
        </div>
        
        <Link to="/" className="btn" style={{ 
          display: 'inline-block',
          marginTop: '20px'
        }}>
          Return to Goosifer Forum
        </Link>
        
        <div style={{ 
          color: 'rgba(0, 191, 255, 0.6)', 
          textAlign: 'center', 
          fontSize: '13px', 
          marginTop: '20px'
        }}>
          <p>The Goosifer Forum community continues to search for answers...</p>
        </div>
      </div>
    </div>
  );
};

export default NotFound; 